<h1 mat-dialog-title>{{ isEditMode ? ('Edit Course' | translate) : ('Create Course' | translate) }}</h1>

<div mat-dialog-content>
  <form [formGroup]="courseForm" style="margin-top: 1rem">

    <mat-form-field [style.width.px]="350" appearance="outline">
      <mat-label>{{ 'Course Name' | translate }}</mat-label>
      <input formControlName="name" matInput placeholder="{{ 'e.g. UEFA Licenca C' | translate }}"/>
      <mat-error *ngIf="courseForm.get('name')?.invalid && courseForm.get('name')?.touched">
        {{ 'Name is required' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field [style.width.px]="350" appearance="outline">
      <mat-label>{{ 'Application Start Date' | translate }}</mat-label>
      <input [matDatepicker]="startPicker" formControlName="startDateOfApplication" matInput/>
      <mat-datepicker-toggle [for]="startPicker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
      <mat-error *ngIf="courseForm.get('startDateOfApplication')?.invalid && courseForm.get('startDateOfApplication')?.touched">
        {{ 'Start date is required' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field [style.width.px]="350" appearance="outline">
      <mat-label>{{ 'Application End Date' | translate }}</mat-label>
      <input [matDatepicker]="endPicker" formControlName="endDateOfApplication" matInput/>
      <mat-datepicker-toggle [for]="endPicker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
      <mat-error *ngIf="courseForm.get('endDateOfApplication')?.invalid && courseForm.get('endDateOfApplication')?.touched">
        {{ 'End date is required' | translate }}
      </mat-error>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button (click)="onCancel()" mat-button>{{ 'Cancel' | translate }}</button>
  <button (click)="onSave()" [disabled]="!courseForm.valid" color="primary" mat-button>
    {{ isEditMode ? ('Update Course' | translate) : ('Create Course' | translate) }}
  </button>
</div>
